import React from 'react';
import cx from 'classnames';
import { NavLink } from 'react-router-dom';

import { ReactComponent as QuipuswapLogo } from 'app/components/svg/QuipuswapLogo.svg';
import { AppRoutes } from 'app/static/routes/routes-enum';
import { MADFISH } from 'app/utils/defaults';

import s from './Sidebar.module.sass';

import { footerList, menuList } from './content';

const Sidebar: React.FC = () => (
  <aside className={cx(s.root)}>
    <NavLink className={cx(s.logo)} to={AppRoutes.OVERVIEW}>
      <QuipuswapLogo />
    </NavLink>

    <div className={cx(s.wrapper)}>
      {
        menuList.length ? (
          <nav className={cx(s.list, s.menu)}>
            {
              menuList.map(({
                item, to, id, Icon,
              }) => (
                <NavLink
                  to={to}
                  key={id}
                  className={cx(s.item)}
                  activeClassName={cx(s.active)}
                >
                  <div className={cx(s.icon)}>
                    <Icon />
                  </div>

                  {item}
                </NavLink>
              ))
            }
          </nav>
        ) : null
        }

      <footer className={cx(s.list, s.footer)}>
        {footerList.length
          ? footerList.map(({
            item, href, id, Icon,
          }) => (
            <a href={href} key={id} className={cx(s.footerItemWrapper)} target="_blank" rel="noreferrer">
              {Icon}
              <span className={cx(s.footerItem)}>
                {item}
              </span>
            </a>
          ))
          : null}
        <a
          href={MADFISH}
          target="_blank"
          rel="noreferrer"
          className={cx(s.author)}
        >
          Madfish.Solutions ❤️
        </a>
      </footer>
    </div>
  </aside>
);

export default Sidebar;
